// Release 2 (F10): clean rich text (opportunity and campaign textarea fields) before it is shown
// with v-html. The fields keep their formatting (bold, lists, links, headings, images...), but
// scripts, event handlers (onerror=...), javascript: links, SVG/MathML and form controls are
// removed. The editor can be bypassed by calling the API directly, so this is done on display.
import DOMPurify from "dompurify";

const CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["style", "form", "input", "button", "textarea", "select", "option"]
};

export function sanitizeHtml(value) {
  if (value === null || value === undefined) return "";
  return DOMPurify.sanitize(String(value), CONFIG);
}

export default sanitizeHtml;
